/**
 * Get the base URL for API requests and static assets (e.g. uploads).
 * In production: REACT_APP_API_URL (e.g. https://b2sforms.onrender.com)
 * In development: http://localhost:5001 (backend dev server)
 * Fallback: when not localhost, use production URL (handles build env issues)
 */
export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined' && !window.location.hostname.includes('localhost')) {
    return 'https://b2sforms.onrender.com';
  }
  return 'http://localhost:5001';
};

/**
 * Get the full URL for an upload path.
 * - /images/{district}/... = on frontend server (same origin), return as-is
 * - /uploads/logos/... = legacy; if subdomain provided, map to /images/{subdomain}/ (frontend)
 * - /uploads/... = other backend uploads, prepend API base URL
 */
export const getUploadUrl = (path, subdomain) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  // Images stored on frontend server (e.g. /images/smartmarketing/logo.png)
  if (path.startsWith('/images/')) return path;
  // Legacy /uploads/logos/ - point to frontend /images/{subdomain}/ (user should re-upload if 404)
  if (path.startsWith('/uploads/logos/') && subdomain) {
    const filename = path.replace('/uploads/logos/', '');
    return `/images/${subdomain}/${filename}`;
  }
  // Other backend uploads
  const base = getApiBaseUrl();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
};
